import React from "react";
import _ from "lodash";
import styles from "./Footer.module.scss";
import { Typography } from "@material-ui/core";
import serviceConfig from "../../../../config/service.json";
const SERVICE = process.env.REACT_APP_SERVICE;
const LOW_PLAN = process.env.REACT_APP_LOW_PLAN;

const Footer = () => (
  <div className={styles.Footer}>
    {serviceConfig !== undefined &&
      SERVICE !== undefined &&
      LOW_PLAN !== undefined &&
      _.get(serviceConfig, SERVICE) !== undefined &&
      _.get(_.get(serviceConfig, SERVICE), LOW_PLAN) !== undefined && (
        <Typography variant="caption">
          Copyright © {_.get(_.get(serviceConfig, SERVICE), LOW_PLAN).name}
        </Typography>
      )}
  </div>
);

export default Footer;
